import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-modal-adicionar-sistema',
  templateUrl: './modal-adicionar-sistema.component.html',
  styleUrls: [ './modal-adicionar-sistema.component.scss' ],
})
export class ModalAdicionarSistemaComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() sistema: { noFormaIntegracao: string; noSistemaIntegracao: string } = {
    noFormaIntegracao: '',
    noSistemaIntegracao: ''
  };
  @Output() fecharModal = new EventEmitter();

  constructor(
    private toast: ToastrService,
  ) {}

  ngOnInit() {
  }

  fechar(data?) {
    this.fecharModal.emit();
  }

  salvar() {
    if (!this.sistema.noSistemaIntegracao.trim()) {
      this.toast.error('Preencha o campo Sistema');
      return;
    }

    if (!this.sistema.noFormaIntegracao.trim()) {
      this.toast.error('Preencha o campo Tipo de integração');
      return;
    }

    this.fecharModal.emit(this.sistema);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal-adicionar-sistema/modal-adicionar-sistema.component.ts